import React, {FC, ReactNode} from 'react';
import {CheckboxProps, TypographyProps, withStyles} from '@material-ui/core';
import Box, {BoxProps} from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import {getDirectionStyles} from '../../utils/ThemeUtils';
import TooltipPopover from '../game-select/TooltipPopover';
import TooltipIconButton from '../game-select/TooltipIconButton';

import {Option} from '../../types';
import {TextEllipsis} from '../game-select/TextEllipsis';

const StyledOptionWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        width: '100%',

        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 4),
            theme.spacing(0, 4, 0, 0)
        )
    }
}))(Box);

interface StyledTextContainer extends BoxProps {
    short?: boolean;
}

const StyledTextContainer = withStyles<string, object, StyledTextContainer>(theme => ({
    root: {
        width: p => (p.short ? '61%' : 'auto'),

        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 2, 0, 0),
            theme.spacing(0, 0, 0, 2)
        )
    }
}))(({short, ...props}: StyledTextContainer) => <Box {...props} />);

export interface MultipleOptionProps extends Pick<Option, 'label' | 'secondaryText'> {
    selected: boolean;
    children?: ReactNode;
    CheckboxProps?: CheckboxProps;
    TypographyProps?: TypographyProps;
    value?: string | number;
}

const RadioOption: FC<MultipleOptionProps> = ({
    label,
    secondaryText,
    value,
    selected,
    children,
    TypographyProps: typographyProps
}: MultipleOptionProps) => {
    const [open, setOpen] = React.useState<boolean>(false);

    const handlePopoverOpen = () => {
        setOpen(true);
    };

    const handlePopoverClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Radio checked={selected} />
            <StyledOptionWrapper>
                <StyledTextContainer clone short={Boolean(secondaryText || children)} mr={1}>
                    <TextEllipsis variant="body1" color="textPrimary" {...typographyProps}>
                        <TooltipPopover open={open} title={label} secondaryText={value}>
                            <span>{label}</span>
                        </TooltipPopover>
                    </TextEllipsis>
                </StyledTextContainer>
                {secondaryText && (
                    <Typography component="span" noWrap color="textSecondary" variant="caption">
                        {secondaryText}
                    </Typography>
                )}
                {children}
            </StyledOptionWrapper>
            {value && value !== 'all' && (
                <TooltipIconButton
                    isOpen={open}
                    onPopoverOpen={handlePopoverOpen}
                    onPopoverClose={handlePopoverClose}
                />
            )}
        </>
    );
};

export default RadioOption;
